var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "link_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#link_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.038 16.538c-1.255 0-2.325-.442-3.21-1.327-.885-.885-1.328-1.955-1.328-3.21 0-1.256.442-2.326 1.328-3.212.885-.885 1.955-1.327 3.21-1.327h3.02c.212 0 .39.071.534.215a.726.726 0 01.216.535c0 .212-.072.39-.216.534a.726.726 0 01-.534.215h-3.02c-.84 0-1.556.297-2.149.89A2.928 2.928 0 004 12c0 .84.296 1.556.89 2.149.592.593 1.308.89 2.147.89h3.02c.213 0 .391.071.535.215a.726.726 0 01.216.535c0 .212-.072.39-.216.534a.726.726 0 01-.534.215h-3.02zM9 12.75a.725.725 0 01-.534-.216A.726.726 0 018.25 12c0-.213.072-.391.216-.535A.726.726 0 019 11.25h6c.213 0 .39.072.534.216a.726.726 0 01.216.534c0 .213-.072.391-.216.535a.726.726 0 01-.534.215H9zm4.942 3.788a.726.726 0 01-.534-.215.726.726 0 01-.216-.535c0-.213.072-.39.216-.534a.726.726 0 01.534-.216h3.02c.84 0 1.556-.296 2.149-.889.592-.593.889-1.31.889-2.149 0-.84-.297-1.556-.89-2.15a2.927 2.927 0 00-2.147-.889h-3.02a.726.726 0 01-.535-.215.726.726 0 01-.216-.535c0-.212.072-.39.216-.534a.726.726 0 01.534-.215h3.02c1.255 0 2.326.442 3.21 1.327.886.885 1.328 1.955 1.328 3.21 0 1.256-.442 2.326-1.328 3.211-.884.886-1.955 1.328-3.21 1.328h-3.02z",
    fill: "#fff"
  }))));
}
export default SvgLink;